<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-26 09:10:59
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-07-26 09:34:34
 * @FilePath: /wemeet-poster/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/components/chooseLink/components/shopTable.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="店铺名称">
            <el-input v-model.trim="queryForm.shopName" clearable placeholder="请输入名称" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryShopData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>
    <el-table
      ref="shopTable"
      v-loading="listLoading"
      border
      :data="list"
      :row-key="getRowKeys"
      style="width: 100%"
      @select="handleSelectionChangeByShop"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="店铺名称" prop="shopName" show-overflow-tooltip />
      <el-table-column label="联系电话1" prop="shopContactNumber" show-overflow-tooltip />
      <el-table-column label="联系地址" prop="shopContactNumber" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.shopProvince }} - {{ row.shopCity }} - {{ row.shopArea }} -
          {{ row.shopAddress }}
        </template>
      </el-table-column>
      <el-table-column label="营业时间" prop="shopBusinessTime" show-overflow-tooltip />

      <el-table-column label="状态" prop="status" show-overflow-tooltip>
        <template #default="{ row }">
          <el-switch
            v-model="row.status"
            active-text="上线"
            disabled
            inactive-text="下线"
            size="large"
            @change="shopStatusChange(row.id, row.status)"
          />
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNumber"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChangeShop"
      @size-change="handleSizeChangeShop"
    />
  </div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import { getShopList } from '@/api/shop'
  export default defineComponent({
    name: 'ShopTable',
    props: {
      multChoose: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { emit }) {
      const state = reactive({
        queryForm: { shopName: '', pageNumber: 1, pageSize: 10 },
        layout: 'prev, pager, next',
        total: 0,
        // 当前选中id
        echoList: [],
        // 记录值
        alreadyChoose: [],
        chooseVal: [],
        shopTable: null,
        listLoading: false,
        list: [],
      })

      const handleSizeChangeShop = (val) => {
        state.queryForm.pageSize = val
        getShopData()
      }
      const handleCurrentChangeShop = (val) => {
        state.queryForm.pageNumber = val
        getShopData()
      }

      const queryShopData = () => {
        getShopData()
      }

      // 增加数据格式类型
      const handleType = (val, type1) => {
        let nArr = JSON.parse(JSON.stringify(val))
        for (let i in nArr) {
          nArr[i]['type'] = type1
        }
        return nArr
      }

      const getShopData = async () => {
        state.listLoading = true
        const { data } = await getShopList(state.queryForm)
        state.list = handleType(data.list, 'shop')
        state.total = data.total
        state.listLoading = false
        if (state.echoList.length > 0) {
          state.list.forEach((item) => {
            // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
            // toggleRowSelection(item, true)：设置当前行数据为选中状态
            if (state.echoList.includes(item.id)) {
              state.shopTable.toggleRowSelection(item, true)
            }
          })
        }
      }

      // 店铺选择
      const handleSelectionChangeByShop = (val, row) => {
        if (!props.multChoose) {
          if (state.echoList.length > 0) {
            state.echoList.forEach((id, index) => {
              if (id === row.id) {
                state.echoList.splice(index, 1)
                state.chooseVal.splice(index, 1)
              } else {
                state.echoList = []
                state.chooseVal = []
                state.echoList.push(row.id)
                state.chooseVal.push(row)
              }
            })
          } else {
            state.echoList = []
            state.chooseVal = []
            state.echoList.push(row.id)
            state.chooseVal.push(row)
          }

          state.list.forEach((item) => {
            if (val[val.length - 1] === item) {
              state.shopTable.toggleRowSelection(item, true)
            } else {
              state.shopTable.toggleRowSelection(item, false)
            }
          })
        } else {
          if (!state.echoList.includes(row.id)) {
            // 回显数据里没有本条，把这条加进来(选中)
            state.echoList.push(row.id)
            state.chooseVal.push(row)
            state.alreadyChoose.push(row)
          } else {
            // 回显数据里有本条，把这条删除(取消选中)
            handleAlreadyData(row, 'shop')
            state.echoList.forEach((id, index) => {
              if (id === row.id) {
                state.echoList.splice(index, 1)
                state.chooseVal.splice(index, 1)
              }
            })
          }
        }
      }
      getShopData()

      return {
        ...toRefs(state),
        handleSizeChangeShop,
        handleCurrentChangeShop,
        queryShopData,
        getShopData,
        handleSelectionChangeByShop,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
